import { SECTION_SCHEMAS } from "../inp/sectionSchema.ts";
import type { ImportTargetSection } from "./importTargets.ts";

// OUTFALLS is the one section `SECTION_SCHEMAS` can't answer statically —
// its real column count depends on the row's own Outfall Type — so import
// only ever produces the simplest (FREE/NORMAL) 3-column shape.
const OUTFALL_IMPORT_COLUMNS = ["Invert Elevation", "Outfall Type", "Tide Gate"];

/** Falls back to "" instead of "0" — every one of these names another element, and "0" would silently reference a real element named "0" instead of nothing. */
const NAME_REFERENCE_COLUMNS = new Set([
  "From Node",
  "To Node",
  "Diverted Link",
  "Raingage",
  "Outlet",
  "Pump Curve",
]);

/** SWMM requires a real enum token here, not a number — an arbitrary default like "0" would be invalid. */
const ENUM_DEFAULTS: Record<string, string> = {
  "Outfall Type": "FREE",
  "Tide Gate": "NO",
  Shape: "FUNCTIONAL",
  "Divider Type": "OVERFLOW",
  Status: "ON",
  "Orifice Type": "SIDE",
  "Weir Type": "TRANSVERSE",
  "Flap Gate": "NO",
  "Rating Type": "TABULAR",
  "Route To": "OUTLET",
};

export function importColumnsFor(section: ImportTargetSection): string[] {
  if (section === "OUTFALLS") return OUTFALL_IMPORT_COLUMNS;
  const columns = SECTION_SCHEMAS[section].columns;
  return typeof columns === "function" ? [] : columns;
}

export function defaultValueFor(column: string): string {
  if (column in ENUM_DEFAULTS) return ENUM_DEFAULTS[column];
  if (NAME_REFERENCE_COLUMNS.has(column)) return "";
  return "0";
}
